import { BasicRequest } from "./basicRequest";

export class PreviewFilterRequest extends BasicRequest{
    public filterDefinitionId!:number;

    constructor(){
        super();
    }
}